export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "organization_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Organisation"])},
        "organization_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Choisir une organisation"])},
        "organization_search_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rechercher une organisation..."])}
      },
      "en": {
        "organization_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Organization"])},
        "organization_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select an organization"])},
        "organization_search_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Search an organization..."])}
      }
    }
  })
}
